import React, { useContext } from 'react'
import { merge } from 'lodash-es'
import { OfferContext } from './offerContext'
import TermInputRadio from './termInputRadio'
import { trackClick } from 'ppbl/utils/fpti-helper'

const TermsInput: React.FC = () => {
  const {
    loanAmount,
    loanTerm,
    setLoanTerm,
    offerOptions,
    fptiData,
    applicationId,
  } = useContext(OfferContext)

  const handleSelection = (e) => {
    let selectedTerms = e.target.value
    setLoanTerm(selectedTerms)
    trackClick(
      merge(fptiData, {
        component: `offerTerm_V1_${selectedTerms}_selected`,
        link: `offerTerm_V1_${selectedTerms}_selected`,
        applicationId,
      }),
    )
  }

  let isSelected = true

  return (
    <>
      <div className="radioGroup">
        {offerOptions.map(
          (
            { label: loanTermLable, value: loanTermValue, maxInput: loanLimit },
            index,
          ) => {
            isSelected = loanTermValue === String(loanTerm)

            return (
              <TermInputRadio
                handleSelection={handleSelection}
                loanTermLable={loanTermLable}
                loanTermValue={loanTermValue}
                isSelected={isSelected}
                loanAmount={parseFloat(loanAmount)}
                loanLimit={loanLimit}
                ind={index}
                key={index}
              />
            )
          },
        )}
      </div>
    </>
  )
}

export default TermsInput
